"use client"

import type React from "react"
import { useState } from "react"
import { JsonEditor } from "./components/JsonEditor"
import { Navbar } from "./components/Navbar"
import { Footer } from "./components/Footer"
import "./index.css"

export default function App() {
  const [jsonData, setJsonData] = useState<Record<string, any>>({})
  const [fileName, setFileName] = useState("badkul-data.json")

  const handleExport = () => {
    const dataStr = JSON.stringify(jsonData, null, 2)
    const dataUri = "data:application/json;charset=utf-8," + encodeURIComponent(dataStr)

    const exportFileDefaultName = fileName || "badkul-data.json"

    const linkElement = document.createElement("a")
    linkElement.setAttribute("href", dataUri)
    linkElement.setAttribute("download", exportFileDefaultName)
    linkElement.click()
  }

  const handleImport = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileReader = new FileReader()
    if (event.target.files && event.target.files.length > 0) {
      fileReader.readAsText(event.target.files[0], "UTF-8")
      setFileName(event.target.files[0].name)
      fileReader.onload = (e) => {
        try {
          const content = e.target?.result as string
          const parsedJson = JSON.parse(content)
          setJsonData(parsedJson)
        } catch (error) {
          alert("Error parsing JSON file. Please ensure it's valid JSON.")
        }
      }
    }
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar onExport={handleExport} onImport={handleImport} fileName={fileName} setFileName={setFileName} />

      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">Badkul Technology JSON Builder</h1>

          <div className="grid gap-6 md:grid-cols-2">
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <h2 className="text-lg font-semibold mb-4">JSON Editor</h2>
              <JsonEditor data={jsonData} onChange={setJsonData} />
            </div>

            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <h2 className="text-lg font-semibold mb-4">JSON Preview</h2>
              <pre className="bg-gray-800 text-green-400 p-4 rounded-md overflow-auto max-h-[600px] text-sm">
                {JSON.stringify(jsonData, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
